export const APP_INITIAL_STATE = {
    app: {
        group: {},
        units: {},
        layers: {},
        canvas: {}
    },
    local: {
        canvas: {},
        group: {},
        units: {},
        layers: {}
    }
};

